import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseCollection } from '../database/offlineDatabase/types/offlineDatabaseCollection.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseCollection, 'id'>(
  () => offlineDatabase.collections,
);

const filterOptionsRepository = createOfflineFilterOptionsRepository<
  OfflineDatabaseCollection,
  'id'
>(() => offlineDatabase.collections, ['name', 'code']);

export const offlineCollectionsRepository = { ...commonRepository, ...filterOptionsRepository };
